import React, { useState, useEffect, useContext } from "react";
import { CloudArrowDown24Regular, CloudCheckmark24Regular, CloudDismiss24Regular } from "@fluentui/react-icons";
import "./Styles/SeriesUploadHistory.css";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import ModalMain from "../../../components/Modal/ModalMain";
import ModalHeader from "../../../components/Modal/ModalHeader";
import ModalFooter from "../../../components/Modal/ModalFooter";
import { t } from "i18next";
import Moment from "moment";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { getSeriesInformation } from "../../../service/StudyListService";
import themeContext from "../../../context/theme/ThemeContext";
import { get } from "jquery";
import { getFormatedDate } from "../../IssuesAndTroubleshooting/helper/helper";

const SeriesUploadHistory = ({ studyId }) => {
  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const [seriesData, setSeriesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { getThemeColor, themeName } = useContext(themeContext);

  useEffect(() => {
    const loadSeriesData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getSeriesInformation(studyId);
        if (response.status !== 200 || response.data.result !== "SUCCESS") {
          setError("Failed to load series information. Please try again.");
        } else {
          setSeriesData(response.data.data || []);
        }
      } catch (err) {
        setError("Failed to load series information. Please try again.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (studyId) {
      loadSeriesData();
    }
  }, [studyId]);

  const formatDateTime = (date) => {
    if (!date || !Moment(date).isValid()) return "-";
    var currentDate = Moment(date).local().format("DD-MMM-YY HH:mm:ss");
    return currentDate;
  };

  if (error) {
    return (
      <div className="series-details-error">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <>
      <div
        className="batch-modal-container"
        style={{ color: getThemeColor("primary-color") }}
      >
        {loading ? (
          <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
        ) : seriesData && seriesData.length == 0 ? (
          <div
            className="batch-modal-empty-state"
            style={{ color: getThemeColor("primary-color") }}
          >
            <div>No series information available for this study.</div>
          </div>
        ) : (
          <div
            className={
              themeName != "light"
                ? "batch-modal-scroll-list"
                : "batch-modal-scroll-list-light"
            }
          >
            {seriesData.map((series, idx) => (
              <div key={series.id} className="batch-modal-request-item">
                <div className="batch-modal-status-row">
                  <div
                    className="batch-modal-file-name"
                    style={{ color: getThemeColor("downloads-heading") }}
                  >
                    <CustomToolTipHost content = {`Series No: ${series.seriesNo}`}>{series.seriesNo} </CustomToolTipHost>
                    {series.seriesDescription && (
                      <>
                        :{" "}
                        <CustomToolTipHost content={`Series Description: ${series.seriesDescription}`}>
                          {series.seriesDescription}
                        </CustomToolTipHost>
                      </>
                    )}
                  </div>
                  <div
                    className="batch-modal-status-text"
                    style={{ color: getThemeColor("downloads-sub-heading") }}
                  >
                    Start: {getFormatedDate(series.seriesCreatedAt,"DD-MMM-YY HH:mm:ss")} 
                  </div>
                </div>
                <div className="batch-modal-status-row">
                  <div
                      className="batch-modal-status-text"
                      style={{ color: getThemeColor("downloads-sub-heading") }}
                    >
                      Total Images: {series.totalImages}
                    </div>
                  
                    <div
                      className="batch-modal-status-text"
                      style={{ color: getThemeColor("downloads-sub-heading") }}
                    >
                      End: {getFormatedDate(series.lastImageCreatedAt,"DD-MMM-YY HH:mm:ss")}
                    </div>
                  
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SeriesUploadHistory;